export default function TrainingAdminMediaItemDirective() {
  return {
    template: require('./media-item.directive.html'),
    controller: 'TrainingAdminMediaItemDirectiveController',
    controllerAs: 'trainingAdminMediaItemVM',
    bindToController: true,
    replace: true,
    scope: {
      topic: '=',
      section: '=',
      media: '=',
    },
  };
}
